import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ApiCallingService } from "../../../services/api-calling.service";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../../common/global";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfigApi } from "../../../config-api";

@Component({
  selector: "app-membership-list",
  templateUrl: "./membership-list.component.html",
  styleUrls: ["./membership-list.component.css"],
})
export class MembershipListComponent implements OnInit {
  @ViewChild("createModal") createModal: any;
  @ViewChild("deleteModal") deleteModal: any;
  membershipList: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  loading: boolean = false;
  modeltitle: any;
  userDetails: any;
  detail: any;
  IdToDelete: string | undefined;
  isEditMode: boolean = false;

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal
  ) {
    let data = localStorage.getItem("Auth-user");
    if (!data) {
      return;
    }
    try {
      this.userDetails = JSON.parse(data);
    } catch (error) {
      console.error(error);
    }
  }

  ngOnInit(): void {
    this.getMembershipList();
  }

  getMembershipList() {
    this.loading = true;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        `${ConfigApi.URLS.MEMBERSHIP.LIST}?page=${pageIndex}&limit=${this.pageSize}&operator_id=${this.userDetails?._id}`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.membershipList = res.data;
            this.totalCount = res.total;
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  onMembershipCreated(membershipData: any) {
    this.modalService.dismissAll();
    this.getMembershipList();
  }

  openModal(targetModal: any, data: any, title: any, isEdit: boolean = false) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });
    this.modeltitle = title;
    this.detail = Object.assign({}, data);
    this.isEditMode = isEdit;
  }
  openDeleteModal(targetModal: any, id: string) {
    this.IdToDelete = id;
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  confirmDelete() {
    this.deleteMembership(this.IdToDelete as string);
    this.modalService.dismissAll();
  }

  deleteMembership(id: string) {
    this.apiCallingService
      .callAPI({}, "DELETE", `${ConfigApi.URLS.MEMBERSHIP.DELETE}/${id}`)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(res.msg);
            this.getMembershipList();
          }
        },
        (error) => {
          this.loading = false;
          this.toastr.error(error.error.msg || "Failed to delete membership");
        }
      );
  }

  closeDeleteModalClick() {
    this.modalService.dismissAll();
    this.IdToDelete = "";
  }

  editMembership(id: string) {
    this.getMembershipDetails(id, true);
  }

  getMembershipDetails(id: string, isEdit: boolean = false) {
    this.apiCallingService
      .callAPI({}, "GET", `${ConfigApi.URLS.MEMBERSHIP.DETAILS}/${id}`)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          const membership = res.data;
          this.openModal(
            this.createModal,
            membership,
            isEdit ? "Edit Membership" : "Add Membership",
            isEdit
          );
        }
      });
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }
  openViewModal(targetModal: any, id: string) {
    this.apiCallingService
      .callAPI({}, "GET", `${ConfigApi.URLS.MEMBERSHIP.DETAILS}/${id}`)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.detail = res.data;
          this.modalService.open(targetModal, {
            centered: true,
            backdrop: "static",
            size: "lg",
          });
        }
      });
  }
}
